import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '../store'
import commRouter from './comm-router'
import pageOutRouter from './page-out-router'

const history = window.sessionStorage
let historyCount = history.getItem('count') * 1 || 0
let historyPath = {
  lengthNum: historyCount
}

Vue.use(VueRouter)
Vue.use(store)
const routeList = []
const updateRoute = router => {
  for (let item of router) {
    routeList.push(item)
  }
}
updateRoute([])
updateRoute(commRouter)
updateRoute(pageOutRouter)

let routers = new VueRouter({
  mode: 'hash',
  // mode: 'history',
  routes: routeList
})
// 修改标题
routers.beforeEach((to, from, next) => {
  store.commit('updateLoadingStatus', {isLoading: true})

  /*const toIndex = history.getItem(to.path)
  const fromIndex = history.getItem(from.path)

  if (toIndex) {
    if (!fromIndex || parseInt(toIndex, 10) > parseInt(fromIndex, 10) || (toIndex === '0' && fromIndex === '0')) {
      store.commit('updateDirection', {direction: 'forward'})
    } else {
      store.commit('updateDirection', {direction: 'reverse'})
    }
  } else {
    ++historyCount
    history.setItem('count', historyCount)
    to.path !== '/' && history.setItem(to.path, historyCount)
    store.commit('updateDirection', {direction: 'forward'})
  }*/


  if (to.meta.title) {
    store.commit('updateTitle', {updateTitle: to.meta.title})
  }
  next()
})
routers.afterEach(function (to) {
  try {
    document.querySelector('.scroll')[0].scrollTop = 0
  } catch (e) {
  }
})
export default routers



// WEBPACK FOOTER //
// ./src/router/index.js